export default __webpack_public_path__ + "static/B203-9615e93c75e66bb7c133a1df7f2efe83.jpg";